__turbopack_context__.v({
  "border--none": "j-7SNG_border--none",
  "borderColor--warning": "j-7SNG_borderColor--warning",
  "button": "j-7SNG_button",
  "colorScheme--muted": "j-7SNG_colorScheme--muted",
  "colorScheme--none": "j-7SNG_colorScheme--none",
  "container": "j-7SNG_container",
  "field": "j-7SNG_field",
  "isEmpty": "j-7SNG_isEmpty",
  "size--lg": "j-7SNG_size--lg",
  "size--sm": "j-7SNG_size--sm",
  "width--maxcontent": "j-7SNG_width--maxcontent",
  "wiggle--a": "j-7SNG_wiggle--a",
  "wiggle--b": "j-7SNG_wiggle--b",
});
